<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
  >
  <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
  <div class="orders-list-filters">
    <nz-select
      class="orders-list-filters__supplier"
      nzPlaceHolder="Lieferant"
      nzShowSearch
      nzServerSearch
      (nzOnSearch)="onSearchSupplier($event)"
      [compareWith]="compareSimpleList"
      nzMode="multiple"
      [(ngModel)]="selectedLastSuppliers"
      (ngModelChange)="onRefreshList()"
      id="lastSupplier"
      >
      @for (o of suppliersList; track o) {
        @if (!isSuppliersLoading) {
          <nz-option [nzValue]="o" [nzLabel]="o.value"></nz-option>
        }
      }
      @if (isSuppliersLoading) {
        <nz-option nzDisabled nzCustomContent>
          <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
        </nz-option>
      }
    </nz-select>
    <nz-select
      class="orders-list-filters__status"
      nzPlaceHolder="Status"
      nzMode="multiple"
      [(ngModel)]="selectedStatuses"
      (ngModelChange)="onStatusFilterChange()"
      id="orderStatus"
      >
      @for (key of statusKeys; track key) {
        <nz-option [nzValue]="key" [nzLabel]="deliveryOrderStatuses[key]"></nz-option>
      }
    </nz-select>
  </div>
</app-table-header>

@if (listReady) {
  <div class="orders-list-result">
    <span>{{ data.info.totalResults }} von {{ unfilteredTotal }} Bestellungen</span>
    @if (hasActiveFilters) {
      <span class="orders-list-result__sep">·</span>
      <a class="orders-list-result__reset" (click)="resetFilters()">Filter zurücksetzen</a>
    }
  </div>
}

<nz-table appColumnLayout id="bulk-container-orders-list-table"
  #tableRef
  nzShowSizeChanger
  [nzScroll]="{ x: tableMaxWidth }"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  >
  <thead>
    <tr>
      <th data-col-key="selection"
        [(nzChecked)]="checked"
        [nzIndeterminate]="indeterminate"
        (nzCheckedChange)="onAllChecked($event)"
        nzWidth="60px"
      ></th>
      <th nzColumnKey="id" [nzSortFn]="true" nzWidth="75px" nzSortOrder="descend">#ID</th>
      <th nzColumnKey="orderDate" [nzSortFn]="true" nzWidth="140px">Bestelltermin</th>
      <th
        nzColumnKey="supplier.name" [nzSortFn]="true"
        nzWidth="300px">
        Lieferant


      </th>
      <th nzColumnKey="isPaid"
        [nzFilters]="paidFilters"
        [nzFilterMultiple]="false"
        [nzFilterFn]="true"
        [nzSortFn]="true"
        (nzFilterChange)="paidFilter = $event"
        nzWidth="200px"
      >Bezahlt</th>

      <th nzColumnKey="isInvoiceUploaded"
        [nzFilters]="invoiceFilters"
        [nzFilterMultiple]="false"
        [nzFilterFn]="true"
        [nzSortFn]="true"
        (nzFilterChange)="invoiceFilter = $event"
        nzWidth="200px"
      >Rechnung</th>
      <th
        nzColumnKey="status"
        [nzSortFn]="true"
        nzWidth="200px"
        >
        Status
      </th>
      <th nzColumnKey="actions" nzRight nzWidth="120px"></th>
    </tr>
  </thead>
  <tbody>
    @for (order of data.results; track order) {
      <tr>
        <td [nzChecked]="setOfCheckedId.has(order.id)" (nzCheckedChange)="onItemChecked(order.id, $event)"></td>
        <td>{{order.id}}</td>
        <td>{{order.orderDate | dateFormat}}</td>
        <td>
          <a [routerLink]="['/suppliers']" [queryParams]="{search: order.supplier.name}">{{order.supplier.name}}</a>
          @if (order.supplier.contactPerson || order.supplier.phoneNumber || order.supplier.email || order.supplier.comment) {
            <i nz-icon nzType="info-circle" nzTheme="outline"
              nz-tooltip
              [nzTooltipTitle]="order.supplier | supplierTooltip"
            style="margin-left: 4px; cursor: help;"></i>
          }
        </td>
        <td>{{order.isPaid | booleanFormat}}</td>
        <td>{{order.isInvoiceUploaded | booleanFormat}}</td>
        <td>
          <nz-select
            class="full-width"
            [(ngModel)]="order.status"
            (ngModelChange)="onStatusChange(order.id, $event)"
            nzPlaceHolder="Status"
            >
            @for (key of statusKeys; track key) {
              <nz-option
                [nzValue]="key"
                [nzLabel]="deliveryOrderStatuses[key]"
              ></nz-option>
            }
          </nz-select>
        </td>
        <td nzRight>
          <div class="actions" style="align-items: center;">
            <span>
              <i
                nz-icon
                nzType="edit"
                nzTheme="outline"
                (click)="modal.showModal(order)"
                nz-tooltip
                nzTooltipTitle="Bestellung bearbeiten"
              ></i>
            </span>
            <span>
              @if (order.documentKey && order.documentKey !== '') {
                <app-download-document
                  [documentKey]="order.documentKey"
                ></app-download-document>
              }
            </span>
            @if (order.status === 'Open' && orderType === orderTypes.NonPacking) {
              <span>
                <i
                  nz-icon
                  nzType="stop"
                  nz-popconfirm
                  nzPopconfirmTitle="Sind Sie sicher?"
                  (nzOnConfirm)="deleteElement(order.id)"
                  nzTheme="outline"
                  nz-tooltip
                  nzTooltipTitle="Bestellung löschen"
                ></i>
              </span>
              <span (click)="openSupplierMail(order.id)">
                <i
                  nz-icon
                  nzType="mail"
                  nzTheme="outline"
                  nz-tooltip
                  nzTooltipTitle="E-Mail an Lieferanten senden"
                ></i>
              </span>
            }
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-add-edit-order-modal (refresh)="onRefreshList(false)" #modal [orderType]="orderType"></app-add-edit-order-modal>
<app-send-order-mail-modal #sendMailModal></app-send-order-mail-modal>
<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
